module.exports = __webpack_public_path__ + "img/icon-security.0d397a5b.png";